export const APPOINTMENT_CREATE = 'APPOINTMENT_CREATE';
export const APPOINTMENT_UPDATE = 'APPOINTMENT_UPDATE';
export const PROFILE_UPDATE = 'PROFILE_UPDATE';

export const redirectLinks = {
  [APPOINTMENT_CREATE]: '/appointment/create',
  [APPOINTMENT_UPDATE]: '/appointment/update',
  [PROFILE_UPDATE]: '/profile/edit',
};
